export enum NotificationsApi {
  Notifications = '/WebAPI/GetUserPushNotificationsAsync',
  MarkNotificationsRead = '/WebAPI/MarkUserPushNotificationsReadTop20'
}
